import { IFormService } from "../../service/form/FormService";

export default class GetReportingPeriodsByApplicantIdInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(applicantId: number) {
    return this.formService.getReportingPeriodsByApplicantId(applicantId);
  }
}
